import React from 'react'

import { NOOP } from 'constants/commonConstans'
import { BrandFormEnum } from 'services/Branding/types'

import CourseStructureFormFonts from './CourseStructureFormFont'
import CourseStructureFormStyle from './CourseStructureFormStyle'
import type {
  CourseStructureFormBrandType,
  CourseStructureBrandForms,
} from './courseStructureTypes'

const FORM_MAP: CourseStructureBrandForms = {
  [BrandFormEnum.STYLE]: CourseStructureFormStyle,
  ...CourseStructureFormFonts,
}

const CourseStructureFormBrand: CourseStructureFormBrandType = (props) => {
  const Form = FORM_MAP[props.form] || NOOP
  return <Form {...props} />
}

export default React.memo(CourseStructureFormBrand) as typeof CourseStructureFormBrand
